import {SavePageViewHitTrackingError} from './SavePageViewHitTrackingError.js'

export class TrackingErrorsFactory {
  static savePageViewHitTrackingError = msg => new SavePageViewHitTrackingError(msg)
}
